import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { RequestsModal } from "../utils";

export const ExternalWorkflowButton = ({ draftId, disabled }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        fluid
        secondary
        onClick={() => setOpen(true)}
        disabled={disabled ?? false}
      >
        Run QC
      </Button>
      <RequestsModal
        open={open}
        onClose={() => setOpen(false)}
        draftId={draftId}
        requestHeader="Run quality check"
        requestType="run_external_workflow"
        confirmationMessage="For publication, the quality check must be successful. Confirm to run the quality check."
      />
    </>
  );
};

ExternalWorkflowButton.propTypes = {
  draftId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
